import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { CONTACT } from "@/i18n/translations";

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  const href = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t.whatsapp.message)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.label}
      data-testid="whatsapp-float-btn"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-[110] group flex items-center gap-3"
    >
      <span className="hidden sm:block opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-[opacity,transform] duration-300 font-mono-spec text-[10px] tracking-[0.18em] uppercase text-[#12261A] bg-white border border-[rgba(20,112,63,0.25)] rounded-full px-4 py-2 backdrop-blur-md shadow-[0_4px_20px_rgba(20,112,63,0.08)]">
        {t.whatsapp.label}
      </span>
      <span className="relative w-14 h-14 rounded-full bg-[#1FA855] flex items-center justify-center shadow-[0_8px_30px_rgba(31,168,85,0.4)]">
        <span className="absolute inset-0 rounded-full bg-[#1FA855] animate-ping opacity-20" />
        <MessageCircle size={24} className="text-white relative" fill="white" />
      </span>
    </motion.a>
  );
};
